import React from 'react'
import { shape, string } from 'prop-types'
import { useHistory } from 'react-router-dom'

import useRouteBuilder from '@hooks/useRouteBuilder'
import useDataLayer from '@hooks/useDataLayer'
import useFunnelStage from '@hooks/useFunnelStage'

import DynamicFlow from '@components/DynamicFlow'

import Checkout from '../Checkout'
import CompanyInfo from '../CompanyInfo'
import CommercialOffer from '../CommercialOffer'
import Success from '../ThankYou'

export default function AcquisitionFlow({ match }) {
  const { setFunnelStage } = useFunnelStage('Brazil')
  const history = useHistory()
  const { buildRoute } = useRouteBuilder()
  const { events } = useDataLayer()

  let dataLayer = {}

  function setDataLayer(step, path, newDataLayer) {
    dataLayer = { ...dataLayer, ...newDataLayer }
    events.simulatorInteractionWithSteps(step, path, dataLayer)
  }

  function redirect(path) {
    history.push(buildRoute(path))
  }

  function changePage(path) {
    history.push(path)
  }

  function onLoad(data) {
    setFunnelStage(data)
  }

  const basePath = match.path.replace('/:origin', '')

  return (
    <DynamicFlow
      onLoad={onLoad}
      actions={{ setFunnelStage, setDataLayer, redirect }}
      changePage={changePage}
      origin={match.url}
      redirect={redirect}
    >
      <CompanyInfo path={`${basePath}/company-info`} />
      <CommercialOffer path={`${basePath}/commercial-offer`} />
      <Checkout path={`${basePath}/checkout`} />
      <Success path={buildRoute('/thank-you/success')} />
    </DynamicFlow>
  )
}

AcquisitionFlow.propTypes = {
  match: shape({
    url: string,
    params: shape({
      origin: string,
    }),
  }).isRequired,
}
